import { SportPeriodFilter } from "@nxplatform/platform-entities/sport/common-sport.entities";
import { __ } from "@service/api-client/http/helpers/translates";
const StorageMenuName = "active-menu";
const queryModalTypeName = "show";
const queryOpenSmartico = "smartico";
const TopSection = "top";
const FavoritesSection = "favorites";
const SportSpecialSection = "special";
const LeagueIds = "leagueIds";
const Boosted = "boosted";
const Leagues = "leagues";
const SocketToken = "socketToken";
const sportTimeFilterTypes = [
  {
    text: __("Default_._Status Filter Type_._All"),
    shortName: __("Default_._Status Filter Type_._All"),
    id: SportPeriodFilter.all
  },
  {
    text: __("Default_._Status Filter Type_._30 min"),
    shortName: __("Default_._Status Filter Type_._30 m"),
    id: SportPeriodFilter["30min"]
  },
  {
    text: __("Default_._Status Filter Type_._1 hour"),
    shortName: __("Default_._Status Filter Type_._1 h"),
    id: SportPeriodFilter["1h"]
  },
  {
    text: __("Default_._Status Filter Type_._3 hour"),
    shortName: __("Default_._Status Filter Type_._3 h"),
    id: SportPeriodFilter["3h"]
  },
  {
    text: __("Default_._Status Filter Type_._6 hours"),
    shortName: __("Default_._Status Filter Type_._6 h"),
    id: SportPeriodFilter["6h"]
  },
  {
    text: __("Default_._Status Filter Type_._12 hours"),
    shortName: __("Default_._Status Filter Type_._12 h"),
    id: SportPeriodFilter["12h"]
  },
  {
    text: __("Default_._Status Filter Type_._24 hours"),
    shortName: __("Default_._Status Filter Type_._24 h"),
    id: SportPeriodFilter["24h"]
  },
  {
    text: __("Default_._Status Filter Type_._48 hours"),
    shortName: __("Default_._Status Filter Type_._48 h"),
    id: SportPeriodFilter["48h"]
  }
];
export {
  Boosted,
  FavoritesSection,
  LeagueIds,
  Leagues,
  SocketToken,
  SportSpecialSection,
  StorageMenuName,
  TopSection,
  queryModalTypeName,
  queryOpenSmartico,
  sportTimeFilterTypes
};
